export function normalizeEntityInfoTypeName(typeName: string): string;
export function normalizeEntityInfoTypeName(typeName: string | undefined): string | undefined;
export function normalizeEntityInfoTypeName(typeName: string | undefined): string | undefined {
  /*! SuppressStringValidation interface name*/
  return typeName ? typeName.replaceAll("[[", ".Of.").replaceAll("]]", "") : typeName;
}
